// extracted by mini-css-extract-plugin
module.exports = {"selectCategoryWindow":"selectCategoryWindow__ukALa"};